exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "header {\r\n\tbackground-color: #fccf31;\r\n\tbackground-image: linear-gradient(141deg, #fccf31 0%, #f55555 100%);\r\n\tcolor: #fff;\r\n}\r\n\r\nheader {\r\n\twidth: 100%;\r\n\theight: 100vh;\r\n\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\talign-content: center;\r\n\tjustify-content: center;\r\n}\r\n\r\nheader * {\r\n\ttext-align: center;\r\n\tcolor: #fff;\r\n}\r\n\r\nheader h1 {\r\n\tfont-size: 4em;\r\n\tcolor: #fff;\r\n}\r\n\r\nheader p.description {\r\n\tpadding: 20px 10%;\r\n\tfont-size:  1.5em;\r\n}\r\n\r\nheader a {\r\n\tfont-weight: bold;\r\n\tcolor: val(--background);\r\n}", ""]);

// exports
